import React from 'react';
import {Modal, Text, Icon, StatusBadge} from '@/ui-kits';
import {SupportTicket} from '@/interface';
import {formatDate} from '@/utils/common_functions';
import {HelpRequestStatus} from '@/constants/enums';
import {HelpRequestStatusBadgeVariants, HelpRequestStatusLabels} from '@/constants';

interface ClosedStatusModalProps {
  open: boolean;
  onClose: () => void;
  ticket: SupportTicket;
}

export const ClosedStatusModal: React.FC<ClosedStatusModalProps> = ({open, onClose, ticket}) => {
  return (
    <Modal open={open} onClose={onClose} className="relative bg-white py-4 px-6 rounded-xl gap-6 w-[90vw] max-w-[700px] max-h-[90vh] overflow-y-auto">
      {/* Close Button */}
      <button onClick={onClose} className="absolute top-4 right-4 size-8 flex items-center justify-center rounded-full hover:bg-gray-100">
        <Icon type="close" className="size-5 text-ui_blue" />
      </button>

      {/* Header Section */}
      <div className="flex items-center gap-4 mb-6">
        <Text variant="free" className="text-ui_blue font-FigtreeBold text-3xl">
          {String(ticket.id)}
        </Text>
        <StatusBadge variant="secondary" status={HelpRequestStatusBadgeVariants[ticket?.status as HelpRequestStatus]}>
          {HelpRequestStatusLabels[ticket?.status as HelpRequestStatus]}
        </StatusBadge>
      </div>

      {/* User Message Section */}
      <div className="mb-6">
        <Text variant="body" className="!text-deep_blue !font-FigtreeSemiBold mb-3 !text-xl">
          User Message
        </Text>
        <div className="bg-ui_user_message_bg/5 rounded-lg p-4 border border-ui_input_border">
          <Text variant="body" className="text-ui_blue whitespace-pre-wrap">
            {ticket.user_message || 'No message provided'}
          </Text>
        </div>
      </div>

      {/* Admin Reply Section */}
      {ticket.admin_message && ticket.admin_subject && ticket.admin_replied_date && (
        <div className="mb-6 bg-ui_reply_section rounded-lg p-3 border border-ui_input_border">
          {/* Admin Reply Header */}
          <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
            <Text variant="body" className="!text-deep_blue !font-FigtreeSemiBold !text-xl flex-shrink-0">
              Admin Reply
            </Text>
            <Text variant="small" className="text-ui_placeholder">
              Sent {formatDate(ticket.admin_replied_date, 'yyyy-MMM-dd, hh:mm:ss')}
            </Text>
          </div>

          {/* Subject */}
          <Text variant="body" className="text-deep_blue mb-3">
            <span className="font-FigtreeSemiBold">Subject: </span>
            <span className="font-FigtreeRegular">{ticket.admin_subject}</span>
          </Text>

          {/* Admin Message */}
          <div className="bg-white border border-ui_input_border rounded-lg p-3">
            <Text variant="body" className="text-ui_blue whitespace-pre-wrap break-words">
              {ticket.admin_message}
            </Text>
          </div>
        </div>
      )}
    </Modal>
  );
};
